/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents } from '@gh/builder-shared-data';
import { ActionFlow, getRouteInitData } from '@gh/common-shared';
import { ReportFyaDetails, ReportFyaDetailsTab } from '../../resources/report-fya-details.model';
import { ReportFyaDetailsCommandService } from './report-fya-details-command.service';
import { ReportFyaDetailsFormState } from './report-fya-details-form.service';

@Component({
  standalone: false,
  selector: 'gh-report-fya-details',
  templateUrl: 'report-fya-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ReportFyaDetailsFormState,
    ReportFyaDetailsCommandService,
  ],
})
export class ReportFyaDetailsComponent extends AbstractFormComponent<ReportFyaDetails> implements OnInit {
  constructor(private route: ActivatedRoute,
              private userContext: BuilderUserContext,
              private navigations: BuilderNavigationService,
              private commands: ReportFyaDetailsCommandService,
              public form: ReportFyaDetailsFormState) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<ReportFyaDetails>> {
    return this.commands.completeFlow;
  }

  ngOnInit(): void {
    const { details } = getRouteInitData(this.route);

    this.form.build(details);
  }

  goToAel(): void {
    this.navigations.goToAel({
      label: 'lbl_financials_ytd_average',
      entityType: this.userContext.masterView ? 'MASTER_ZONE' : void 0,
      entityId: this.userContext.masterView ? this.userContext.masterZone!.id : void 0,
      eventTypeIds: [AelEvents.Reports.Fya.Edited],
    });
  }

  onReset(): void {
    this.commands.reset();
  }

  onSelectedTabChange(tab: ReportFyaDetailsTab): void {
    this.commands.selectTab(tab);
  }
}
